/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 * 
 * ThemeProvider - Provides design tokens to all components via React Context
 * Works with styled-components theme prop and can be accessed via useTheme hook
 */

import React, { createContext, useContext } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import tokens from './design-tokens';

const ThemeContext = createContext(tokens);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    // Fallback to tokens if context is not available
    return tokens;
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  return (
    <ThemeContext.Provider value={tokens}>
      <StyledThemeProvider theme={tokens}>
        {children}
      </StyledThemeProvider>
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;

